import { render, staticRenderFns } from "./RandomRewards.vue?vue&type=template&id=6e23fb27"
import script from "./RandomRewards.vue?vue&type=script&lang=js"
export * from "./RandomRewards.vue?vue&type=script&lang=js"
import style0 from "./RandomRewards.vue?vue&type=style&index=0&id=6e23fb27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports